// Module
var code = "<div class=\"gc-tooltip\"> {{ progressbar }} {{ description }} {{ close }} {{ copyright }} {{ customButtons }} {{ notification }} </div>";
// Exports
export default code;